import { PropsWithChildren, useEffect, useState } from 'react';
import { fetchTranslates } from 'api/http-client/queries/strapi';
import { isVac } from 'utilities/is-vac';
import { applyVacEnglishCopy, TranslatesByLang, vacSeed } from 'utilities/vac-copy';
import { Language } from './enums';
import { TranslatesContext } from './context';
import { getLangFromLocalStorage, obtainTransl, setLangToLocalStorage } from './helpers';

interface Props {}

const htmlLangFor = (lang: string) => (lang === Language.FRENCH ? 'fr' : 'en');

export const TranslatesProvider = (props: PropsWithChildren<Props>) => {
  const [selectedLang, setSelectedLang] = useState(getLangFromLocalStorage());
  const [translates, setTranslatesState] = useState<TranslatesByLang | undefined>(
    () => (isVac() ? vacSeed() : undefined)
  );

  const setLang = (lang: string) => {
    setSelectedLang(lang);
    setLangToLocalStorage(lang);
  };

  const setTranslates = (raw: any) => {
    setTranslatesState(applyVacEnglishCopy(obtainTransl(raw)));
  };

  useEffect(() => {
    document.documentElement.lang = htmlLangFor(selectedLang);
  }, [selectedLang]);

  useEffect(() => {
    if (!isVac()) {
      return;
    }
    fetchTranslates().then(setTranslates);
  }, []);

  return (
    <TranslatesContext.Provider
      value={{
        selectedLang,
        translates: (translates ? translates[selectedLang] : {}),
        setTranslates,
        setSelectedLang: (lang: string) => setLang(lang),
      }}
    >
      {props.children}
    </TranslatesContext.Provider>
  );
};
